import Pagination from './Pagination';

export default Pagination;



/** WEBPACK FOOTER **
 ** ./components/pagination/index.jsx
 **/